module.exports = "/images/burgerizzr.png?f1e6323e410cda43ae90a1a31d846377";